var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProblem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5475 0H3.9525L0 3.9525V9.5475L3.9525 13.5H9.5475L13.5 9.5475V3.9525L9.5475 0ZM12 8.925L8.925 12H4.575L1.5 8.925V4.575L4.575 1.5H8.925L12 4.575V8.925Z",
    fill: "url(#paint0_linear_7191_1069)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 10.5C7.16421 10.5 7.5 10.1642 7.5 9.75C7.5 9.33579 7.16421 9 6.75 9C6.33579 9 6 9.33579 6 9.75C6 10.1642 6.33579 10.5 6.75 10.5Z",
    fill: "url(#paint1_linear_7191_1069)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3H7.5V8.25H6V3Z",
    fill: "url(#paint2_linear_7191_1069)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7191_1069",
    x1: 6.75,
    y1: 0,
    x2: 6.75,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#726FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7191_1069",
    x1: 6.75,
    y1: 9,
    x2: 6.75,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#726FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7191_1069",
    x1: 6.75,
    y1: 3,
    x2: 6.75,
    y2: 8.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#726FBA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblem);
export default __webpack_public_path__ + "static/media/problem.6c5288e814231657ba6e8fb94dd7a70b.svg";
export { ForwardRef as ReactComponent };